import type {
    RibbonTabDefinitionBase,
    RibbonTabDefinitionSet,
} from '@1js/acui-ribbon-like/lib/UISurfaces/Ribbon/components';
import type { RibbonControlDefinitionProps } from 'owa-mail-ribbon-utils';
import getMLRReadTab from 'owa-mail-ribbon/lib/components/MLR/mlr-read-tab/getMLRReadTab';

export const getReadingPaneProjectionDefinitionMLR = (
    props: RibbonControlDefinitionProps
): RibbonTabDefinitionSet => {
    const mlrTabs: RibbonTabDefinitionBase[] = [getMLRReadTab(props)];

    return {
        tabs: mlrTabs,
    };
};
